export const DEFAULT_AVATAR_PRESETS = [
  {
    id: 'preset-1',
    variant: 'boy',
    background: '#e0f2fe',
    hair: '#1e3a8a',
    skin: '#f8c9a9',
    shirt: '#0284c7',
  },
  {
    id: 'preset-2',
    variant: 'girl',
    background: '#dcfce7',
    hair: '#3f3f46',
    skin: '#f6c7a8',
    shirt: '#16a34a',
  },
  {
    id: 'preset-3',
    variant: 'boy',
    background: '#fef3c7',
    hair: '#78350f',
    skin: '#f1b98e',
    shirt: '#d97706',
  },
  {
    id: 'preset-4',
    variant: 'girl',
    background: '#ffe4e6',
    hair: '#831843',
    skin: '#f7c6ac',
    shirt: '#e11d48',
  },
  {
    id: 'preset-5',
    variant: 'boy',
    background: '#ede9fe',
    hair: '#312e81',
    skin: '#eec1a3',
    shirt: '#7c3aed',
  },
  {
    id: 'preset-6',
    variant: 'girl',
    background: '#ccfbf1',
    hair: '#134e4a',
    skin: '#f2c0a2',
    shirt: '#0d9488',
  },
  {
    id: 'preset-7',
    variant: 'boy',
    background: '#e2e8f0',
    hair: '#334155',
    skin: '#efc2a2',
    shirt: '#64748b',
  },
  {
    id: 'preset-8',
    variant: 'girl',
    background: '#fae8ff',
    hair: '#701a75',
    skin: '#f4c1aa',
    shirt: '#c026d3',
  },
  {
    id: 'preset-9',
    variant: 'boy',
    background: '#cffafe',
    hair: '#164e63',
    skin: '#f0bc98',
    shirt: '#0891b2',
  },
  {
    id: 'preset-10',
    variant: 'girl',
    background: '#fee2e2',
    hair: '#7f1d1d',
    skin: '#f5c2a8',
    shirt: '#dc2626',
  },
];

export const isDefaultAvatarPreset = (value?: string) => {
  return DEFAULT_AVATAR_PRESETS.some((preset) => preset.id === value);
};

export const getDefaultAvatarPresetUrl = (value?: string) => {
  const preset =
    DEFAULT_AVATAR_PRESETS.find((item) => item.id === value) ||
    DEFAULT_AVATAR_PRESETS[0];
  const hair =
    preset.variant === 'girl'
      ? `<path d="M22 31c0-10 4-16 10-16s10 6 10 16c0 5-2 9-3 12-2-3-4-4-7-4s-5 1-7 4c-1-3-3-7-3-12z" fill="${preset.hair}"/>`
      : `<path d="M23 26c1-7 5-11 10-11 4 0 8 3 9 8-4-2-7-2-10-1-4 2-6 1-9 4z" fill="${preset.hair}"/>`;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="32" fill="${preset.background}"/><path d="M18 52c2-10 7-15 14-15s12 5 14 15" fill="${preset.shirt}"/>${hair}<circle cx="32" cy="27" r="7" fill="${preset.skin}"/><circle cx="29.5" cy="27" r="1" fill="#1f2937"/><circle cx="34.5" cy="27" r="1" fill="#1f2937"/><path d="M29 31c2 1.5 4 1.5 6 0" stroke="#1f2937" stroke-width="1.4" stroke-linecap="round" fill="none"/></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};
